export default "__VITE_ASSET__Bbi37jiJ__"